import { ContactoModel } from "./contacto-model";

export class Prescriptor {
    id: number;
    descripcion: string = '';
    ciudad: string = '';
    retribuido: boolean | null = null;
    // contratoID: number;
    salesPersonCode?: number | null;
    categoriaId?: number | null = null ;
    empresa?: string = '';
    direccion?: string = '';
    codPostal?: string = '';
    comunidadAutonoma?: number;
    provincia?: number;
    pais?: string = '';
    tipoRetribucion?: string = '';
    observaciones?: string = '';
    contactos?: ContactoModel[];
    // createdBy: string;
    // updatedBy: string;
    // updatedDate: string;
    // createdDate: string;
    // createdByName: string;
    // updatedByName: string;
}
